import { memo } from 'react';
import styled from 'styled-components';

import RateItFeedBottomStack from './RateItFeedBottomStack';
import RateItHeader from './RateItHeader';
import RateItMedia from './RateItMedia';
import { RATE_IT_COLORS } from '../constants';

const Card = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: ${RATE_IT_COLORS.CARD_BG};
`;

/**
 * One full-bleed moment: media behind, the header over the top, the creator row and the rating
 * bar over the bottom.
 *
 * Holds NO rating state — only what to render.
 * Everything about the rating (the optimistic highlight, the toast, the request, the
 * auto-advance) lives in `RateItFeed`, because this card can unmount at any moment and the brief
 * requires that navigating away never cancel a rating in flight. See that file's docblock.
 *
 * `memo`'d because the feed re-renders on every index change while typically only one card's
 * props actually differ.
 */
const RateItItemCard = ({
  item,
  isActive,
  isMounted,
  isMuted,
  isPaused,
  onTogglePause,
  selectedRating,
  ratingLocked,
  onRate,
  onBack,
  onVideoEnd,
  viewCount,
  tallies
}) => (
  <Card>
    <RateItMedia
      item={item}
      isActive={isActive}
      isMounted={isMounted}
      isMuted={isMuted}
      isPaused={isPaused}
      onTogglePause={onTogglePause}
      onEnded={onVideoEnd}
    />

    <RateItHeader onBack={onBack} />

    <RateItFeedBottomStack
      // The creator row sits in the bottom stack, just above the tiles — see that file.
      creator={item.creator}
      // Passed by the feed, which adds this session's own counted views to `item.viewCount`.
      viewCount={viewCount ?? item.viewCount ?? 0}
      selected={selectedRating}
      // Passed by the feed, which overlays this session's optimistic and confirmed counts.
      tallies={tallies ?? item.tallies}
      disabled={ratingLocked}
      onRate={(rating) => onRate(item._id, rating)}
    />
  </Card>
);

export default memo(RateItItemCard);
